import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse, Alert } from '../models';



@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/alerts`;

  getAlerts(resolved?: boolean, startDate?: string, elevatorId?: number): Observable<Alert[]> {
    let url = this.baseUrl;
    const params: string[] = [];
    if (resolved !== undefined) {
      params.push(`resolved=${resolved}`);
    }
    if (startDate !== undefined) {
      params.push(`startDate=${encodeURIComponent(startDate)}`);
    }
    if (elevatorId !== undefined) {
      params.push(`elevatorId=${elevatorId}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    return this.http.get<ApiResponse<Alert[]>>(url).pipe(
      map(res => res.data)
    );
  }

  resolveAlert(id: number): Observable<Alert> {
    return this.http.post<ApiResponse<Alert>>(`${this.baseUrl}/${id}/resolve`, {}).pipe(
      map(res => res.data)
    );
  }

  getAlertsCount(): Observable<number> {
    return this.http.get<ApiResponse<{ count: number }>>(`${this.baseUrl}/count`).pipe(
      map(res => res.data.count)
    );
  }
}
